import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { usePrefs, useRequestData, useLabels } from 'wsm-common-data';
import { setClassNames } from 'ddc-classnames-js';
import { galleryTrackingEvents } from '../../utilities/tracking';
import GalleryButton from './GalleryButton';

const GalleryToolbar = (props) => {
	const { setActiveToolbar, onOpenModal } = props;
	const { galleryToolbarStyle, galleryToolbarPlacement, imgThumbStyle } =
		usePrefs();
	const { imagesToDisplay = [], videos = [] } = useSelector(
		(state) => state.media
	);
	const { deviceType, widgetName, windowId } = useRequestData();
	const labels = useLabels();
	const isMobile = deviceType === 'MOBILE';
	const isHorizontalStyle = imgThumbStyle === 'horizontal';

	// With vertical imgThumbStyle, always use text mode
	const isTextLinkMode =
		!isHorizontalStyle || galleryToolbarStyle === 'text' || isMobile;

	let btnSpace;
	if (isHorizontalStyle) {
		btnSpace = isMobile || galleryToolbarStyle !== 'text' ? 'mx-3' : 'mx-5';
	} else {
		btnSpace = 'mr-3';
	}

	const hasVideo = videos.length > 0;

	if (imagesToDisplay.length === 0) {
		return null;
	}

	const thumbnailUrl = imagesToDisplay[0].thumbnail || '';

	const marginToolbar =
		galleryToolbarPlacement === 'top-left' ? 'mb-4' : 'mt-4';

	const positionToolbar =
		galleryToolbarPlacement === 'top-left'
			? 'absolute-top ml-4 mt-4'
			: 'absolute-bottom ml-4 mb-4';
	const vehicleLinkContainerClass = [
		'd-flex',
		'align-items-center',
		'justify-content-center',
		marginToolbar
	];

	const TOTAL_IMAGES = imagesToDisplay.length;

	const handleTrackingPhotoCountButton = () =>
		galleryTrackingEvents.clickPhotoCountToolbar(widgetName, windowId, {
			elementCTA: `${TOTAL_IMAGES} Photos`
		});
	const handleTrackingClickAllPhotos = () =>
		galleryTrackingEvents.clickAllPhotosButton(widgetName, windowId);
	const handleTrackingClickVideo = () =>
		galleryTrackingEvents.clickVideoButton(widgetName, windowId);

	const renderGalleryButton = (
		icon,
		btnLabel,
		activeToolbarIndex,
		handleTrackingEvent
	) => (
		<GalleryButton
			btnLabel={btnLabel}
			btnSpace={btnSpace}
			handleClick={() => {
				onOpenModal();
				setActiveToolbar(activeToolbarIndex);
				handleTrackingEvent();
			}}
			icon={icon}
			isOverlayButton={!isHorizontalStyle}
			isTextLinkMode={isTextLinkMode}
			thumbnailUrl={thumbnailUrl}
		/>
	);

	return (
		<>
			{isHorizontalStyle ? (
				<div className={setClassNames(vehicleLinkContainerClass)}>
					{renderGalleryButton(
						'ddc-icon-images2',
						labels.get('ALL_PHOTOS'),
						0,
						handleTrackingClickAllPhotos
					)}
					{hasVideo &&
						renderGalleryButton(
							'ddc-icon-play3',
							labels.get('VIDEO'),
							1,
							handleTrackingClickVideo
						)}
				</div>
			) : (
				<span
					data-testid="vertical-toolbar"
					className={`vehicle-gallery-toolbar ${positionToolbar}`}
				>
					{renderGalleryButton(
						'ddc-icon-images2',
						`${TOTAL_IMAGES} ${labels.get('PHOTOS')}`,
						0,
						handleTrackingPhotoCountButton
					)}
					{hasVideo &&
						renderGalleryButton(
							'ddc-icon-play3',
							labels.get('VIDEO'),
							1,
							handleTrackingClickVideo
						)}
				</span>
			)}
		</>
	);
};

GalleryToolbar.propTypes = {
	onOpenModal: PropTypes.func.isRequired,
	setActiveToolbar: PropTypes.func.isRequired
};

export default GalleryToolbar;
